import { FetchBusinessUnitsResponse } from "./types";
import axiosInstance from "../axiosInstance";

export const fetchBusinessUnits = async (
  companyUuid: string,
): Promise<FetchBusinessUnitsResponse> => {
  const response = await axiosInstance.get<FetchBusinessUnitsResponse>(
    `/api/private/companies/${companyUuid}/service-titan/business-units`,
  );
  return response.data;
};
